import axios from 'axios';

const isLocal = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const API_URL = isLocal ? `http://localhost:8001` : `${window.location.protocol}//${window.location.hostname}/api`;

const api = axios.create({
    baseURL: API_URL,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const login = (username, password) =>
    api.post('/login', `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });

export const getSummary = () => api.get('/summary');
export const getMachines = () => api.get('/machines');
export const getAlarms = () => api.get('/alarms');
export const getFinancial = () => api.get('/financial');
export const getWorkOrders = () => api.get('/workorders');
export const createWorkOrder = (data) => api.post('/workorders', data);
export const getStock = () => api.get('/stock');
export const getMaintenance = () => api.get('/maintenance');
export const getEnergySummary = (start, end) => api.get(`/energy/summary${start && end ? `?start=${start}&end=${end}` : ''}`);
export const getKaizen = () => api.get('/kaizen');
export const createKaizen = (data) => api.post('/kaizen', data);
export const getKaizenSuggestions = () => api.get('/kaizen/suggestions');
export const getWaste = () => api.get('/waste');
export const getCapacityPlan = (product, qty) => api.get(`/capacity-plan/${product}?quantity=${qty}`);


// ============================================================
// OPEMENT_AUTH_401_INTERCEPTOR
// Süresi dolan veya geçersiz oturumu güvenli şekilde kapatır.
// ============================================================

let opementAuthRedirectInProgress = false;

const clearOpementAuthSession = () => {
  const authKeys = [
    "token",
    "access_token",
    "accessToken",
    "authToken",
    "jwt",
    "username",
    "role",
    "tenant_id",
    "tenantId",
    "user",
    "currentUser",
    "impersonation_token",
    "original_token",
  ];

  authKeys.forEach((key) => {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  });
};

api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") ||
      sessionStorage.getItem("token") ||
      localStorage.getItem("access_token") ||
      sessionStorage.getItem("access_token");

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    } else if (config.headers?.Authorization) {
      delete config.headers.Authorization;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = String(
      error?.config?.url || ""
    ).toLowerCase();

    const isLoginRequest =
      requestUrl.includes("/login") ||
      requestUrl.includes("/token") ||
      requestUrl.includes("/auth/login");

    const currentPath =
      window.location.pathname.toLowerCase();

    const isAlreadyOnLoginPage =
      currentPath === "/login" ||
      currentPath.startsWith("/login/");

    // Optional/global UI requests must never destroy an otherwise valid
    // authenticated session. Super Admin also renders shared components
    // such as AI/theme/notifications which may legitimately return 401
    // depending on role or tenant context.
    const isNonFatal401Request =
      requestUrl.includes("/ai/status") ||
      requestUrl.includes("/users/me/preferences") ||
      requestUrl.includes("/notifications");

    if (
      status === 401 &&
      !isLoginRequest &&
      !isAlreadyOnLoginPage &&
      !isNonFatal401Request &&
      !opementAuthRedirectInProgress
    ) {
      opementAuthRedirectInProgress = true;

      clearOpementAuthSession();

      const returnPath =
        window.location.pathname +
        window.location.search;

      window.location.replace(
        `/login?reason=session_expired&returnTo=${encodeURIComponent(
          returnPath
        )}`
      );
    }

    return Promise.reject(error);
  }
);


export default api;

